import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Contact} from "../../../company/company.model";
import {Model} from "../../../app.model";
import {AutorunComponent} from "@myshared/autorun.component";
import {CompanyService} from "../../../company/company.service";
import {MessageService} from "primeng/api";
import {I18NextService} from "angular-i18next";
import {FormEmitter} from "../../../forms/form.component";

@Component({
    selector: 'app-select-invoice-contact-create',
    templateUrl: './select-invoice-contact-create.component.html',
    standalone: false
})
export class SelectInvoiceContactCreateComponent extends AutorunComponent implements OnInit {
  @Input() companyId: string;
  @Output() public readonly created = new EventEmitter<Contact>();

  public isPC20CSP: boolean;

  constructor(
    private m: Model,
    private companyService: CompanyService,
    private messageService: MessageService,
    private i18next: I18NextService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.autorun(() => {
      this.isPC20CSP = this.m.account.currentUser.companyIsPC20Csp;
    });
  }

  public formSubmit(form: FormEmitter<Contact>): void {
    const contact = form.data;
    contact.id = '';
    contact.email = this.isPC20CSP ? '' : contact.email;
    contact.invite_user = this.isPC20CSP ? false : contact.invite_user;
    contact.mypascom_account = 'disabled';
    contact.company_id = this.companyId;

    if (this.isPC20CSP) {
      this.addCspContact(contact);
      return;
    }

    this.addContact(contact);
  }

  private addCspContact(contact: Contact) {
    if (this.isPC20CSP) {
      this.companyService.addCSPContact(contact).subscribe(r => {
        this.messageService.add({severity: 'success',
          summary: this.i18next.t('success') as string,
          detail: this.i18next.t('contact_created') as string});
        this.created.emit(Contact.fromJson(r));
      });
    }
  }
  private addContact(contact: Contact) {
    this.companyService.inviteContact(contact).subscribe((r) => {
      if (contact.invite_user) {
        this.messageService.add({severity: 'success',
          summary: this.i18next.t('success') as string,
          detail: this.i18next.t('contact_invited') as string});
      } else {
        this.messageService.add({severity: 'success',
          summary: this.i18next.t('success') as string,
          detail: this.i18next.t('contact_created') as string});
      }
      this.created.emit(Contact.fromJson(r));
    });
  }
}
